import * as i0 from '@angular/core';
import { EventEmitter, Injectable, Inject } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

class RazorpayPgService {
    constructor(environment, http) {
        this.environment = environment;
        this.http = http;
        this.paymentModalClosed = false;
        this.paymentModalClosedEvent = new EventEmitter(false);
        this.paymentClickedEvent = new EventEmitter(false);
        this.DEFAULT_COLOR = "#2A86F3";
        this.DEFAULT_BACKDROP_COLOR = "#111218e6";
    }
    changePaymentStatus(paymentDetails) {
        let { booking_id, order_id, transfer_id } = paymentDetails;
        let paymentStatusPayload = Object.assign({}, booking_id && { booking_id }, order_id && { order_id }, transfer_id && { transfer_id });
        if (Object.keys(paymentStatusPayload)?.length === 0) {
            throw new Error('Payment status change failed.');
        }
        return this.http
            .post(this.environment.apiUrlPaV1 + 'payments/change_status', paymentStatusPayload)
            .toPromise();
    }
    initiatePayment(bookingDetails) {
        this.paymentClickedEvent.emit(true);
        let paymentDetails = {};
        paymentDetails = {
            ...bookingDetails,
            transactions_attributes: [{
                    'txn_type': 'payment_gateway',
                    'amount': bookingDetails?.amount,
                }]
        };
        if (this.paymentModalClosed) {
            this.reInitiatePayment(paymentDetails);
        }
        else {
            this.makePayment(paymentDetails);
        }
    }
    ondismissCallback(paymentDetails) {
        this.paymentModalClosedEvent.emit(true);
        try {
            this.changePaymentStatus(paymentDetails.booking_id).then((response) => {
                this.paymentClickedEvent.emit(false);
            });
        }
        catch (error) {
            console.log(error);
        }
    }
    reInitiatePayment(paymentDetails) {
        this.paymentClickedEvent.emit(true);
        this.changePaymentStatus(paymentDetails.booking_id).then((response) => {
            if (response.status == "success" || response.status == "user_cancelled") {
                this.paymentModalClosedEvent.emit(false);
                this.makePayment(paymentDetails);
            }
            else {
                this.paymentClickedEvent.emit(false);
            }
        }, error => {
            this.paymentClickedEvent.emit(false);
        });
    }
    createPayment(data, discounted_project_id = false) {
        let httpOptions = {};
        if (discounted_project_id) {
            httpOptions = {
                headers: new HttpHeaders({
                    'discounted_project_id': 'true'
                })
            };
        }
        return this.http
            .post(this.environment.apiUrlPaV1 + 'payments', data, httpOptions)
            .toPromise();
    }
    makePayment(paymentDetails, isDiscountedGc = false, color = this.DEFAULT_COLOR, backdrop_color = this.DEFAULT_BACKDROP_COLOR) {
        this.createPayment(paymentDetails, isDiscountedGc).then((payment) => {
            if (payment.status == 'error') {
                this.paymentClickedEvent.emit(false);
                throw new Error(payment.msg);
            }
            if (payment.redirect_url) {
                window.location.href = payment.redirect_url;
                return;
            }
            payment["modal"] = {
                ondismiss: () => { this.ondismissCallback(paymentDetails); },
                animation: true
            };
            payment["theme"] = {
                color: color,
                backdrop_color: backdrop_color
            };
            payment["webview_intent"] = true;
            let rzp1 = new Razorpay(payment);
            rzp1.open();
        });
    }
}
RazorpayPgService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RazorpayPgService, deps: [{ token: 'env' }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
RazorpayPgService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RazorpayPgService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RazorpayPgService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }, { type: i1.HttpClient }]; } });

/*
 * Public API Surface of razorpay-pg
 */

/**
 * Generated bundle index. Do not edit.
 */

export { RazorpayPgService };
